import { gql } from '@apollo/client/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import { DynamicComponent } from '../';
import useRegistration from './useRegistration';

/**
 *
 * @param {object} props
 * @param {object} props.style
 * @param {Array.<'fullName' | 'title' | 'email' | 'website' | 'telephone' | 'companyName'>} props.includeAttributes - specify which attributes and their order
 * @returns
 */
export default function PrimaryContacts({
  style,
  includeAttributes = ['fullName', 'title', 'email', 'website'],
  ...rest
}) {
  const registration = useRegistration();
  if (!hasContent(registration)) return null;
  const primaryContacts = registration.primaryContacts?.[0];
  return (
    <DynamicComponent.Wrapper style={style} {...rest}>
      <DynamicComponent.Label {...rest}>
        <Trans>Contact</Trans>
      </DynamicComponent.Label>
      {includeAttributes.map((parameter) => (
        <DynamicComponent.Value
          key={Math.floor(Math.random() * 1000)}
          {...rest}
        >
          {primaryContacts[parameter]}
        </DynamicComponent.Value>
      ))}
    </DynamicComponent.Wrapper>
  );
}

PrimaryContacts.hasContent = hasContent;

function hasContent(registration) {
  return !!registration.primaryContacts?.[0]?.fullName;
}

PrimaryContacts.fragment = gql`
  fragment PrimaryContacts on SingleRegistration {
    primaryContacts {
      contactId
      fullName
      companyName
      title
      email(format: TEXT)
      website(format: TEXT)
      telephone
    }
  }
`;
